import { motion } from "framer-motion";
import Link from "next/link";
import { Col, Container, Row } from "reactstrap";
import JobSearch from "@sourceflow-uk/job-search";
import styles from "./styles.module.scss";
import BreadCrumb from "../../components/Shared/BreadCrumb";

export const MainBanner = ({
  customClass = "",
  content,
  title,
  heading,
  image,
  breadcrumb_title,
  secondary_breadcrumb_url,
  secondary_breadcrumb_title,
  displayImage1,
  buttonLink,
  buttonTitle,
  button_1_class,
  buttons = [],
  buttonLayout = "horizontal",
  jobSearch = false,
  locale = "https://www.bartechstaffing.com",
  // returnButtonLink,
  // returnButtonTitle,
}) => {
  const variants_1 = {
    hidden: { opacity: 0.005, y: 40 },
    visible: { opacity: 1, y: 0, transition: { duration: 0.5, delay: 0.05 } },
  };
  const variants_2 = {
    hidden: { opacity: 0.005, y: 40 },
    visible: { opacity: 1, y: 0, transition: { duration: 0.5, delay: 0.2 } },
  };

  const buttonContainerClasses =
    buttonLayout === "vertical"
      ? "d-flex flex-column align-items-start gap-3 mt-4"
      : "d-flex flex-wrap align-items-center gap-3 mt-4";

  return (
    <section
      className={`${
        styles.root
      } ${customClass} position-relative overflow-hidden ${
        displayImage1 ? "" : "hidden-image-1"
      }`}
    >
      <Container>
        <Row className="m-0">
          <Col
            lg={6}
            className="contentWrapper d-flex flex-wrap align-items-center position-relative"
          >
            <div className={`position-relative wrapper mb-4 w-100`}>
              {breadcrumb_title && (
                <BreadCrumb
                  title={
                    <>
                      {/* MODIFICATION: Used Next.js Link for "Solutions" */}
                      {secondary_breadcrumb_url && (
                        <span>
                          <Link href={secondary_breadcrumb_url}>
                            <a>{secondary_breadcrumb_title}</a>
                          </Link>
                        </span>
                      )}

                      <span className="active">{breadcrumb_title}</span>
                    </>
                  }
                  className={`py-2`}
                />
              )}
            </div>
            <div>
              {/* {returnButtonLink && (
                <Link href={returnButtonLink}>
                  <a className="return-text text-nowrap arrow-left d-inline-flex align-items-center white mb-4">
                    <strong>{returnButtonTitle}</strong>
                  </a>
                </Link>
              )} */}
              <motion.div
                initial="hidden"
                animate="visible"
                variants={variants_1}
              >
                <h1 className={`${heading}`}>{title}</h1>
                {content && (
                  <div dangerouslySetInnerHTML={{ __html: content }} />
                )}
              </motion.div>

              {jobSearch ? (
                <motion.div
                  className="mt-4"
                  initial="hidden"
                  animate="visible"
                  variants={variants_2}
                >
                  <JobSearch
                    options={{
                      searchResults: false,
                      searchFilters: false,
                      submitDestination: `${locale ? locale : ""}/jobs`,
                    }}
                    translations={{
                      "input.placeHolder": "Job Title or Keyword",
                    }}
                  />
                </motion.div>
              ) : buttons && buttons.length > 0 ? (
                <div className={buttonContainerClasses}>
                  {buttons.map((button, index) => {
                    const isLink =
                      button.variant === "secondaryLink" ||
                      button.variant === "secondaryLinkWhite";
                    const finalButtonClass = `${
                      button.variant || "primaryBtn"
                    } ${!isLink ? "no-arrow" : ""} m-0`;

                    return (
                      <Link href={button.href || "#"} key={`button-${index}`}>
                        <a
                          className={finalButtonClass}
                          target={button.newTab ? "_blank" : "_self"}
                          rel={
                            button.newTab ? "noopener noreferrer" : undefined
                          }
                        >
                          {button.label}
                        </a>
                      </Link>
                    );
                  })}
                </div>
              ) : buttonLink && buttonTitle ? (
                <div className="mt-4">
                  <a
                    href={`${buttonLink}`}
                    className={`${button_1_class} no-arrow m-0`}
                  >
                    {buttonTitle}
                  </a>
                </div>
              ) : null}
            </div>
          </Col>
          {displayImage1 && (
            <Col lg={6} className="position-relative mainImageWrapper">
              <img
                src={
                  image?.url
                    ? image.url
                    : "/site-assets/placeholders/img-placeholder.jpg"
                }
                width={1000}
                alt={image?.alt}
                className="card-img rounded-4"
              />
            </Col>
          )}
        </Row>
        <div className="imageWrapper position-absolute p-0">
          <img
            src={"/site-assets/svg/main-banner-overlay.svg"}
            alt={`main-banner-overlay`}
          />
        </div>
      </Container>
    </section>
  );
};

export default MainBanner;
